import React from "react";

import { AddableModuleType } from "@formant/core/model/AddableModuleType";
import { Icon, IconName, IconSize } from "@formant/ui/component/common/Icon";

export interface IStreamIconProps {
    type: AddableModuleType;
    size?: IconSize;
}

export const StreamIcon = (props: IStreamIconProps) => {
    const { type, size } = props;
    const icon = streamTypeIcons[type];
    return icon ? <Icon name={icon} size={size} /> : null;
};

export const appTypeIcons: Record<string, IconName> = {
    "Multi-Numeric": "numeric",
    "Command Manager": "play",
    "Numeric Aggregate": "numeric",
    Terminal: "commandTerminal",
    "3D Viewer": "pointcloud",
    // Heatmap: "heatmap",
    // "Dev Module": "",
    // "AI Module": "",
    // Ekobot: "",
    // Hello: "",
    // "Prompt Tester": "",
    // "Local heatmap": "",
    // "Test No Query";
    // controls: "play",
    default: "cube",
};

export const dashboardTypes = ["dashboard", "navigator", "analytics"] as const;
export type DashboardType = (typeof dashboardTypes)[number];

export const dashboardTypeIcons: Record<DashboardType, IconName> = {
    dashboard: "dashboard",
    navigator: "joystick",
    analytics: "numeric",
};

export const streamTypeIcons: Record<AddableModuleType, IconName> = {
    boolean: "bitset",
    image: "image",
    numeric: "numeric",
    "point cloud": "cube",
    text: "text",
    json: "json",
    location: "location",
    file: "file",
    localization: "localization",
    health: "health",
    bitset: "bitset",
    "transform tree": "cube",
    battery: "battery",
    video: "video",
    "numeric set": "numeric",
    custom: "bitset",
    analytics: "bitset",
    controls: "play",
    twist: "joystick",
    "joystick-controls": "play",
    "button-controls": "play",
    terminal: "bitset",
};
